module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.f4985a12.webp";